import { SelectList } from 'app/components/SelectList';
import { selectCourseVariables } from 'core/selectors/admin/courseVariables';
import { selectVariable } from 'core/selectors/admin/variable';
import { useAppSelector } from 'core/store/hooks';

export function CourseVariableSelector({
  variableId,
  onSelect,
}: {
  variableId: number;
  onSelect: (variableId: number) => void;
}) {
  const courseVariables = useAppSelector(selectCourseVariables);
  const variable = useAppSelector(state => selectVariable(state, variableId));

  return (
    <SelectList
      label={'Select record'}
      onChange={onSelect}
      value={variableId}
      className="w-80 overflow-visible"
      listClassName="max-h-24"
      items={[variable, ...courseVariables.map(cv => cv.variable)]
        .filter(v => !!v)
        .map(variable => {
          return { value: variable.id, name: variable.text?.shortText || variable.name };
        })}
    />
  );
}
